import { istTelefonFreitext, pruefeTelefon, telefonVerlassen } from "@kmvs/forms-core";

/**
 * Telefon-Prüfung/-Normalisierung für Formulare — dünne Hülle um das
 * einheitliche Telefonformat „+49 221 123456-78" aus `@kmvs/forms-core`
 * (telefon.ts). Früher E.164 über libphonenumber-js; seit 09/2026 dieselbe
 * Schreibweise wie in den Eingabefeldern (useTelefonFeld).
 */

const s = (input: unknown): string => String(input ?? "");

/** Erlaubte Zeichen beim Tippen (Ziffern, +, gängige Trenner). Buchstaben raus. */
export function stripPhoneInput(input: string): string {
  return s(input).replace(/[^\d+\s()/-]/g, "");
}

/**
 * Speicherform im KMVS-Format; Freitext (mit Buchstaben) bleibt unverändert,
 * leer bleibt leer. `geschaeftlich` (Default: ja) entscheidet, ob eine
 * geschriebene Durchwahl „-" erhalten bleibt — ohne Angabe geht nichts
 * verloren.
 */
export function normalizePhone(input: string, opts: { geschaeftlich?: boolean } = {}): string {
  const trimmed = s(input).trim();
  if (!trimmed) return "";
  if (istTelefonFreitext(trimmed)) return trimmed;
  return telefonVerlassen(trimmed, { geschaeftlich: opts.geschaeftlich ?? true });
}

/** Validierung. Leere Eingabe = gültig (optionales Feld). */
export function validatePhone(input: string): { valid: boolean; error?: string } {
  const fehler = pruefeTelefon(s(input));
  return fehler ? { valid: false, error: fehler } : { valid: true };
}
